/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Try_Magic_CharactersInputs */

const en_try_magic_characters = /** @type {(inputs: Try_Magic_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} / ${i?.max} characters`)
};

const es_try_magic_characters = /** @type {(inputs: Try_Magic_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} / ${i?.max} caracteres`)
};

/**
* | output |
* | --- |
* | "{count} / {max} characters" |
*
* @param {Try_Magic_CharactersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_characters = /** @type {((inputs: Try_Magic_CharactersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_CharactersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_characters(inputs)
	return en_try_magic_characters(inputs)
});